// Full fule override
import { log } from 'log';
import { EventEmitterService } from 'js/services/eventEmitter.service';

log('nesting', 'Lecensee dispatcher.js');

class Dispatcher extends EventEmitterService {
    dispatch(eventName, ...args) {
        this.trigger(eventName, ...args);
    }

    listen(eventName, callback) {
        this.on(eventName, callback);
    }
}

export const dispatcher = new Dispatcher();
